module.exports = __webpack_public_path__ + "img/food-supplements.7fd59502.jpg";